import { createPerimeter } from 'vue-kindergarten';
import store from '@/store';
export default createPerimeter({
  purpose: 'user',
  can: {
    read(){
      return this.isApproved();
    },
    accessPremium(){
        let self = this.can || this;
        return self.isElevated() || ((store.getters['user/isManager'] || store.getters['user/isFlexAgency']) && store.state.user.data.companies[0].premium );
    },
    isPremium(){
        let self = this.can || this;
        if( self.isElevated() || ((store.getters['user/isManager'] || store.getters['user/isFlexAgency']) && store.state.user.data.companies[0].premium ) ){
            return true;
        }
    },
    accessCalendar(){
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isFlexAgency'] || store.getters['user/isPlanner'] || store.getters['user/isFlexAgency'] || store.getters['user/isFlexEmployee']  || store.getters['user/isTemp'] || store.getters['user/isFreelancer']
    },
    accessUsers(){
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isHRManager'] || store.getters['user/isFlexAgency']; 
    },
    accessCompanies(){
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isFlexAgency'];
    },
    accessDepartments(){
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isFlexAgency'];
    },
    accessDocuments(id){
      let self = this.can || this;
      // IF OWN PROFILE ONLY VISIBLE FOR TEMP / FREELANCER
      if(store.state.user.data.id === id && (store.getters['user/isTemp'] || store.getters['user/isFreelancer'] )){
        return true;
      }else if(store.state.user.data.id === id && (self.isElevated() || store.getters['user/isManager']  || store.getters['user/isFlexAgency'] || store.getters['user/isFlexEmployee'])){
        return false;
      }

      // OTHERWISE ONLY VISIBLE FOR ADMIN,MANAGER, HRMANAGER;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isHRManager'] || store.getters['user/isFlexAgency'] || store.getters['user/isFlexEmployee'];
    },
    accessCertificates(id){
      let self = this.can || this;
      // IF OWN PROFILE ONLY VISIBLE FOR TEMP / FREELANCER
      if(store.state.user.data.id === id && (store.getters['user/isTemp'] || store.getters['user/isFreelancer'] )){
        return true;
      }else if(store.state.user.data.id === id && (self.isElevated() || store.getters['user/isManager']  || store.getters['user/isFlexAgency'] || store.getters['user/isFlexEmployee'])){
        return false;
      }

      // OTHERWISE ONLY VISIBLE FOR ADMIN,MANAGER, HRMANAGER;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isHRManager'] || store.getters['user/isFlexAgency'] || store.getters['user/isFlexEmployee'];
    },
    
    createEmployees() {
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isHRManager'] || store.getters['user/isFlexAgency'];
    },
    editEmployees() {
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'];
    },
    approveUsers() {
      let self = this.can || this;
      return self.isElevated();
    },
    editUser(id){
      let self = this.can || this;
      // IF USER IS SELF ALLOW EDIT
      if(store.state.user.data.id === id){
        return true;
      }
      return self.isElevated() || store.getters['user/isManager'];
    },
    editDepartment()  {
      let self = this.can || this;
      return self.isElevated() || store.getters['user/isManager'] || store.getters['user/isFlexAgency'];
    },
    isAdmin(){
      return store.getters['user/isAdmin'];
    },
    isPlanner(){
      return store.getters['user/isPlanner'];
    },
    isFranchise(){
      return store.getters['user/isFranchise'];
    },
    isSubAdmin(){
      return store.getters['user/isSubAdmin'];
    },
    isRegular(){
      return !( store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']);
    },
    isElevated(){
      return ( store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']);
    }
  }
});



// WEBPACK FOOTER //
// ./src/permissions/basePerimeter.js